import React, { Component } from "react";
import * as handler from "../components/utils/handler";
import { DataService } from "../services/data.service";
import ModalHead from "./../components/modal-head/modalHead";
import PrimaryButton from "../components/utils/primaryButton";
const queryString = require("query-string");

const runApp = window["app-config"].runApp;
const UI = window["app-config"].ui.userDetailsScreen;
const { isUserAuthenication } = window["app-config"].applicationProperties;

class Login extends Component {
  dataService = new DataService();

  state = {
    lang: {},
    isLoggin: true,
    username: null,
    password: null,
    dataLoaded: false,
  };

  componentDidMount() {
    sessionStorage.setItem("isLogin", false);
    this.setState({ lang: handler.setTranslations() });
  }

  onLoginClick = () => {
    if (this.state.username === "admin" && this.state.password === "admin") {
      sessionStorage.setItem("isLogin", true);
      this.props.history.push("/");
    } else {
      handler.showErrMsg(
        this.state.lang.Attention,
        this.state.lang.LoginFieldsEmptyMsg,
        this.state.lang.Ok,
        window.location.href
      );
    }
  };

  onUsernameChange = (e) => {
    this.setState({ username: e.target.value });
  };

  onPasswordChange = (e) => {
    this.setState({ password: e.target.value });
  };

  render() {
    return (
      <>
        <div className="container">
          <div className="sl__modal">
            <ModalHead
              address={""}
              heading={this.state.lang.StaticHeaderHeading}
            />
            <div className="sl__modal-inner">
              <div className="sl__modal--content">
                <h2 style={{ color: UI.headingColor }}>
                  {this.state.lang.Login}
                </h2>

                <div className="sl__modal_form-row">
                  <div className="sl__modal_form-col"></div>

                  <div className="sl__modal_form-col">
                    <label
                      className="sl__modal_form--label"
                      style={{ color: UI.fColor }}
                    >
                      {this.state.lang.username}
                      <span
                        className="estaric"
                        style={{ color: UI.requiredEstaricColor }}
                      >
                        *
                      </span>
                    </label>
                    <input
                      onChange={this.onUsernameChange}
                      type="text"
                      name="username"
                      maxLength={20}
                      placeholder={this.state.lang.usernamePlaceholder}
                      id="firstname-field"
                      className="sl__modal_form--input validate-text firstname"
                    />
                  </div>
                  <div className="sl__modal_form-col"></div>
                </div>

                <div className="sl__modal_form-row">
                  <div className="sl__modal_form-col"></div>

                  <div className="sl__modal_form-col">
                    <label
                      className="sl__modal_form--label"
                      style={{ color: UI.fColor }}
                    >
                      {this.state.lang.password}
                      <span
                        className="estaric"
                        style={{
                          color: UI.requiredEstaricColor,
                        }}
                      >
                        *
                      </span>
                    </label>
                    <input
                      onChange={this.onPasswordChange}
                      type="password"
                      name="password"
                      maxLength={20}
                      placeholder={this.state.lang.passwordPlaceholder}
                      id="surname-field"
                      className="sl__modal_form--input validate-text"
                    />
                  </div>

                  <div className="sl__modal_form-col"></div>
                </div>

                <div className="sl__modal_form-row">
                  <div className="sl__modal_form-col">
                    <PrimaryButton
                      bgColor={"#1428a0"}
                      onClick={this.onLoginClick}
                    >
                      {/* {this.state.dataLoaded === false ? (
                        <i className="fa fa-spinner fa-spin"></i>
                      ) : null} */}
                      &nbsp;
                      {this.state.issueQrTicket === true
                        ? this.state.lang.TakeATicket
                        : this.state.isLoggin === true
                        ? this.state.lang.SignIn
                        : this.state.lang.SignupBtnText}
                    </PrimaryButton>
                  </div>
                </div>

                <div className="sl__modal_form-row">
                  <div className="sl__modal_form-col">
                    <a
                      onClick={() => {
                        this.props.history.push("signup-user");
                      }}
                    >
                      {this.state.lang.Signup}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Login;
